import React from "react";

interface LayoutControlContextType {
  isErrorComponent: boolean;
  setIsErrorComponent: (value: boolean) => void;
}

export const LayoutControlContext =
  React.createContext<LayoutControlContextType>({
    isErrorComponent: false,
    setIsErrorComponent: () => {},
  });
